import { Table, TableCell, TableContainer, TableHead, TableRow, TableBody, Typography } from "@mui/material";
import { useTotalTreeWeights } from "services/hooks";
import styles from "./../checkout.module.scss";
import { useAppSelector } from "store/hooks";
import { options } from "services/options";
import { formatter } from "services/misc";
import { PRICE, PRICE_LIFETIME } from "services/config";

const Breakdown = () => {    
  const calculation = useTotalTreeWeights();
  const { selection, years } = useAppSelector((state) => state.wizard);

  const calculateMobility = () => {
    let total = options[0]["list"][selection[0] - 1]["weight"]; // Means of Transport
    total = total + selection[1] + selection[2]; // Commercial and Private Flights
    return total;
  }

  const calculateConsumption = () => {
    let total = options[3]["list"][selection[3] - 1]["weight"];
    total = total + options[4]["list"][selection[4] - 1]["weight"];
    total = total + options[5]["list"][selection[5] - 1]["weight"];
    return total.toFixed(2);
  }
  
  const calculateHousehold = () => {
    const modificator = selection[7];
    let total = options[6]["list"][selection[6] - 1]["weight"];
    if(modificator === 1) {
      total = total/2;
    }
    return total.toFixed(2);
  }

  const price = (years < 50 ? PRICE : PRICE_LIFETIME) * calculation.totalTrees * years;
  
  return (
    <>
      <TableContainer className="mb-3">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Breakdown</TableCell>
              <TableCell align="right">Emissions (TC)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                Mobility
              </TableCell>
              <TableCell align="right">{calculateMobility()}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                Consumption
              </TableCell>
              <TableCell align="right">{calculateConsumption()}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                Household
              </TableCell>
              <TableCell align="right">{calculateHousehold()}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                Trees to plant
              </TableCell>
              <TableCell align="right"><strong>{calculation.totalTrees}</strong></TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                Cost per tree
              </TableCell>
              <TableCell align="right"><strong>{formatter.format((years < 50 ? PRICE : PRICE_LIFETIME) * years)}</strong></TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                Total
              </TableCell>
              <TableCell align="right"><strong>{formatter.format(price)}</strong></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <div className="row justify-content-center">
        <div className="col-lg-8 col-12 text-center">
          <Typography variant="body2" lineHeight={2}>To offset <span className={`${styles.highlight}`}>{calculation.carbonTonnes}</span> tonns of carbon emissions you need to plant <span className={`${styles.highlight}`}>{calculation.totalTrees}</span> Mangrove Trees.</Typography>
        </div>
      </div>
    </>
  );
};
export default Breakdown;
